import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'class-names';
import Swiper from 'swiper';
import { fetchItem } from '../../redux/recentItems/actions';
import { options } from '../../components/card-swiper';
import IconArrowLeft from '../icons/IconArrowLeft';
import IconArrowRight from '../icons/IconArrowRight';
import IconChevronLeft from '../icons/IconChevronLeft';
import IconChevronRight from '../icons/IconChevronRight';
import RecentItemFurniture from './RecentItemFurniture';
import RecentItemHomeware from './RecentItemHomeware';

class RecentItemsContent extends Component {
  constructor(props) {
    super(props);
    const { fetchItem } = props;

    const recents = localStorage.getItem('recentlyViewed') ? JSON.parse(localStorage.getItem('recentlyViewed')) : [];
    recents.forEach(({
      handle,
      measurements,
      shippingRegion,
    }) => fetchItem({
      handle,
      measurements,
      shippingRegion,
    }));

    this.swiperOuter = React.createRef();
  }

  componentDidMount() {
    options.navigation = {
      nextEl: '.recent-items-next',
      prevEl: '.recent-items-prev',
    };
    options.scrollbar = {
      el: '.recent-items-swiper-scrollbar',
      hide: false,
    };

    const swiperOuterEl = this.swiperOuter.current;

    if (swiperOuterEl.classList.contains('card-swiper--v-center-nav')) {
      const repositionNav = () => {
        const slideImg = swiperOuterEl.querySelector('.card-swiper__slide img');

        if (slideImg) {
          const imgHeight = slideImg.clientHeight;
          const swiperArrows = swiperOuterEl.querySelectorAll('.swiper-arrow-prev, .swiper-arrow-next');

          swiperArrows.forEach((arrowEl) => {
            arrowEl.style.top = (imgHeight > 0) ? `${imgHeight / 2}px` : null;
          });
        }
      };

      options.on = {
        update: () => { setTimeout(repositionNav, 10); },
        resize: repositionNav,
      };
    }

    this.swiper = new Swiper('[data-react-component="RecentItems"] .card-swiper', options);
  }

  componentDidUpdate(prevProps) {
    const { items } = this.props;
    if (prevProps.items !== items) {
      this.swiper.update();
    }
  }

  render() {
    const { items } = this.props;
    return (
      <div className={classNames({ 'd-none': items.length === 0 })}>
        <div className="container text-center">
          <hr className="mb-5" />
          <h2 className="mb-5">Recently Viewed</h2>
        </div>
        <div className="card-swiper__outer swiper-container-outer card-swiper--v-center-nav" ref={this.swiperOuter}>
          <div className="swiper-container card-swiper">
            <div className="card-swiper__wrapper swiper-wrapper">
              {
                items.map((product) => (
                  <div className="card-swiper__slide swiper-slide" key={product.id}>
                    {product.type === 'Furniture' && (<RecentItemFurniture product={product} />)}
                    {product.type !== 'Furniture' && (<RecentItemHomeware product={product} />)}
                  </div>
                ))
              }
            </div>
            <div className="swiper-scrollbar recent-items-swiper-scrollbar d-md-none" />
          </div>
          <div className="swiper-chevron-prev d-md-none recent-items-prev"><IconChevronLeft /></div>
          <div className="swiper-chevron-next d-md-none recent-items-next"><IconChevronRight /></div>
          <div className="swiper-arrow-prev d-none d-md-block recent-items-prev"><IconArrowLeft /></div>
          <div className="swiper-arrow-next d-none d-md-block recent-items-next"><IconArrowRight /></div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchItem,
};

const mapStateToProps = (state) => ({
  items: state.recentItems.items,
});

RecentItemsContent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchItem: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecentItemsContent);
